import {
    AddCartParam,
    UpdateGoodsQtyParam,
    CartStockPriceQueryParamVo,
    CartStockPriceVo,
    CoIdAndSpuId,
    OrderSupplierGoods
} from '@servicesTypings/goodsRequest'
import { PurchaseCarLogisticsCostConfigVo } from '@servicesTypings/companyRequest'
import { companyRequest, goodsRequest } from '@/utils/request'
import { FreightsListType } from './freights'

// 添加到采购车
export function addCar(data) {
    // /goods/channelCart/addCart 新
    // /buyer/gylBuyerCar/addCars  旧
    return goodsRequest.post('/goods/channelCart/addCarBySpuIds', {
        data
    })
}
// 添加单个sku的
/**
 * 加入采样车
 */
export function addCarBySku(data: AddCartParam[]): API.Res<object> {
    return goodsRequest.post('/goods/channelCart/addCart', { data })
}

interface CreateOrderRes {
    oid: string
    distributeOrder: boolean
    setExpress: boolean
    setExpressErrMsg: string
    /**
     * 对应供应商是否开通推单自动扣减余额
     */
    autopay: boolean
}

// 生成采样单 校验协议
export function createOrderV2(data: any): Promise<API.RootObject<CreateOrderRes | null>> {
    return companyRequest.post('/cart/createErpOrderV2', {
        data
    })
}

// 生成采样单
export function createOrder(data: any): Promise<API.RootObject<CreateOrderRes | null>> {
    return companyRequest.post('/cart/createErpOrder', {
        data
    })
}

// 采购车下单，必须已经签署电子合同，支持多供应商下单并设置快递
export function placePurchaseOrderAfterSignAgreement(data: any): Promise<API.RootObject<CreateOrderRes | null>> {
    return companyRequest.post('/cart/placePurchaseOrderAfterSignAgreement', {
        data
    })
}

// 创建ERP订单(采购车下单)
export function placePurchaseOrder(data: any): Promise<API.RootObject<CreateOrderRes | null>> {
    return companyRequest.post('/cart/placePurchaseOrder', {
        data
    })
}

// 删除采购车商品
/**
 * 删除采样车商品
 */
export function deleteCar(data: string[]): API.Res<object> {
    return goodsRequest.post('/goods/channelCart/delete', { data })
}

// 查询采购车数量（新增）
/**
 * 采样车商品数量
 */
export function queryCarCount(): API.Res<number> {
    return goodsRequest.get('/goods/channelCart/count')
}

// 修改采购车数量
/**
 * 修改采样车数量
 */
export function updateCarQty(data: UpdateGoodsQtyParam): API.Res<object> {
    return goodsRequest.post('/goods/channelCart/updateGoodsQty', { data })
}

interface SkuParamList {
    iid: string // styleCode
    qty: number
    skuId: string
    weight: number
}

// 注释意味着有这个字段，不用传
interface PurchaseLogisticsFreightsData {
    drpCoIdTo: number
    // ignoreAddress: boolean
    // noLcs: any[]
    receiverCity: string
    receiverDistrict: string
    receiverState: string
    skuParamList: SkuParamList[]
    // type: string
    volume: string | null
    weight: number
}
interface FetchPurchaseLogisticsFreightsRes {
    purchaseLogisticsFreights: FreightsListType
    matchingFreight: FreightsListType
}

// 查询采购车的物流费用
export function fetchPurchaseLogisticsFreights(
    data: PurchaseLogisticsFreightsData
): Promise<API.RootObject<FetchPurchaseLogisticsFreightsRes>> {
    return companyRequest.post('/cart/queryPurchaseLogisticsFreights', {
        data
    })
}

// 查询采样车商品(新)
export function queryCartGoods(data) {
    return goodsRequest.post('/goods/channelCart/queryCartGoods', {
        data: data || {}
    })
}

// 查询采样车商品库存及供货价
/**
 * 查询采样车商品库存及供货价
 */
export function queryDisStockAndPrice(data: CartStockPriceQueryParamVo): API.Res<CartStockPriceVo[]> {
    return goodsRequest.post('/goods/channelCart/queryDisStockAndPrice', { data })
}

// 商品详情下单查询供应商品信息
/**
 * 商品详情下单查询供应商品信息
 */
export function querySupplierGoodsForOrder(data: CoIdAndSpuId): API.Res<OrderSupplierGoods> {
    return goodsRequest.post('/buyer/supplier/querySupplierGoodsForOrder', { data })
}

/**
 * 查询采购车的物流费用分片配置
 * @param data
 * @returns
 */
/**
 * 查询采购车的物流费用分片配置
 */
export function getPurchaseCarLogisticsCostConfig(): API.Res<PurchaseCarLogisticsCostConfigVo> {
    return companyRequest.post('/cart/getPurchaseCarLogisticsCostConfig')
}
